import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Permiso } from "@/shared/types/permiso";
import { useIsInitialMonetizacionSetQuery } from "../api/is-initial-monetization-set";
import { useGetCotizacionQuery } from "../api/get-cotizacion";
import { useGetMonedasQuery } from "../api/get-monedas";
import { useGetTransferenciaMetodosQuery } from "../api/get-trasnferencia-metodos";

export default function useInitMonetizacion() {
    const { isLoggedIn, hasPermisos } = useAuthContext();

    // RootAdmin no necesita monetización configurada
    const isRootAdmin = hasPermisos(Permiso.ManageOrganizaciones);

    const { data: isMonetizacionSet, isLoading: isMonetizacionLoading, error: monetizacionError } = useIsInitialMonetizacionSetQuery({
        enabled: isLoggedIn && !isRootAdmin
    });
    const { data: cotizacion, isLoading: isCotizacionLoading, error: cotizacionError } = useGetCotizacionQuery({
        enabled: Boolean(isLoggedIn && isMonetizacionSet && !isRootAdmin)
    });
    const { data: monedas, isLoading: isMonedasLoading, error: monedasError } = useGetMonedasQuery({
        enabled: Boolean(isLoggedIn && isMonetizacionSet && !isRootAdmin)
    });
    const { data: transferenciaMetodos, isLoading: isTrasnferenciaMetodosLoading, error: transferenciaMetodosError } = useGetTransferenciaMetodosQuery({
        enabled: Boolean(isLoggedIn && isMonetizacionSet && !isRootAdmin)
    });

    const loading = isCotizacionLoading || isMonedasLoading || isTrasnferenciaMetodosLoading || isMonetizacionLoading;
    const error = cotizacionError || monedasError || transferenciaMetodosError || monetizacionError || undefined;

    // Para RootAdmin, devolver valores por defecto
    if (isRootAdmin) {
        return {
            loading: false,
            error: undefined,
            isMonetizacionSet: true, // RootAdmin no necesita configuración
            cotizacion: null as any,
            monedas: [] as any,
            transferenciaMetodos: [] as any
        };
    }

    return {
        loading,
        error,
        isMonetizacionSet: isMonetizacionSet!,
        cotizacion: cotizacion!,
        monedas: monedas!,
        transferenciaMetodos: transferenciaMetodos!
    }
}